import {
    IDeviceInformation, IDeviceItemGrouping, IDeviceItemVisitor, IDeviceNode,
    IDynamicControlsSharedState, IStaticInputList
} from '../shared/models/device';

import { DeviceService } from '../shared/services/device.service';
import { DeviceCategory } from '../shared/models/device-category';
import { ElementTypes } from '../shared/models/models';

export class StaticListTabVisitor implements IDeviceItemVisitor {
    public service: DeviceService;
    public currentGrouping: IDeviceItemGrouping;

    public init(
        rootNode: IDeviceNode,
        device: IDeviceInformation,
        sharedState: IDynamicControlsSharedState
    ) {
        // empty
    }

    public canVisit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode): boolean {
        return this.isRoot(owningObject) && this.isStaticList(propValue);
    }

    public visit(owningObject: IDeviceNode, propName: string, propValue: IDeviceNode): IDeviceItemGrouping {
        let staticList: IStaticInputList = propValue as IStaticInputList;

        staticList.$ignoreChildren = true;

        staticList.items.forEach(item => {
            let category = new DeviceCategory(item.value);
            propValue.$isContainer = true;

            this.currentGrouping.$selectedCategory = 0;
            this.currentGrouping.$categories.push(category);

            let controlInput = item.value;
            controlInput.$ignoreChildren = true;

            var section: IDeviceItemGrouping = {
                displayText: '',
                isVisible: controlInput.isVisible,
                $categories: [],
                $controlInputs: [],
                $sections: []
            };

            category.$sections.push(section);

            this.service.visitDeviceStructure(controlInput, section);
        });

        return this.currentGrouping; // Make current grouping.
    }

    private isRoot(node: IDeviceNode) {
        return node.elementType === ElementTypes.Root;
    }

    private isStaticList(node: IDeviceNode) {
        return node.elementType === ElementTypes.ElementList;
    }
}
